import AudioPlayer from "./modules/AudioPlayer";
import FocusOnCenter from "./modules/FocusOnCenter";
import "./cookie_modal.js";

document.addEventListener("DOMContentLoaded", function () {
    FocusOnCenter.run()
    window.FocusOnCenter = FocusOnCenter;

    /*
    * Открыть/закрыть мобильное меню
    * */
    (function () {
        const mobileMenu = document.getElementById("mobile-menu")
            , btn = document.querySelector(".js-mobile-menu-btn")

        if (mobileMenu && btn) {
            btn.addEventListener("click", function (e) {
                e.preventDefault()

                const isActive = mobileMenu.classList.contains("active")

                if (isActive) {
                    btn.classList.remove("active")
                    mobileMenu.classList.remove("active")
                } else {
                    btn.classList.add("active")
                    mobileMenu.classList.add("active")
                }
            })
        }
    })();

    /*
    * Плавающие лейблы для инпутов
    * */
    (function () {
        const inputs = document.querySelectorAll(".input input");

        const checkIsFilled = (input) => {
            if (input.value) input.classList.add("filled");
            else input.classList.remove("filled");
        }

        inputs.forEach(input => {
            const label = input.parentElement.querySelector(".label");

            checkIsFilled(input);
            input.addEventListener('input', event => checkIsFilled(event.currentTarget));

            if (label) label.classList.add("initialised");
        })
    })();

    /*
    * Маска номера телефона
    * */
    (function () {
        if (typeof Inputmask === undefined) return;

        const inputPhoneMask = document.querySelectorAll("input.phone-mask");

        inputPhoneMask.forEach(input => {
            Inputmask({
                regex: "^\\+[0-9]{10,13}$",
                showMaskOnHover: false,
                onBeforePaste: function (pastedValue) {
                    return pastedValue.replace(/[^0-9]/gim, "").slice(1);
                }
            }).mask(input);
        });
    })();

    /*
    * Проигрыватель аудио для карточек озвучки
    * */
    document.querySelectorAll(".play-audio").forEach(item => initAudioPlayer(item))
})

window.initAudioPlayer = (container) => {
    const audio = container.querySelector("audio")
        , progressBar = container.querySelector(".play-audio__progress");

    new AudioPlayer({
        audio,
        progressBar,
        playPauseButton: container,
    })
}
